// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1680px) {
  .payment-page {
    width: 80%;
  }
}

.selected-payment {
  height: 37.9px;
  padding: 11px;
  border: 1px solid #d9d0d0;
  border-radius: 10px;
  background: #f6f6f6;
  font-size: 12px;
  color: #c8c8c8;
  min-width: 145px;
}

.total-block {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 1rem;
  margin-top: 5rem;
}

.payment-modal {
  width: 50%;
  max-height: 90%;
}
.payment-modal::-webkit-scrollbar {
  width: 8px;
}
.payment-modal::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 8px;
}
@media (min-width: 1000px) and (max-width: 1300px) {
  .payment-modal {
    width: 80%;
  }
}
@media (max-width: 1000px) {
  .payment-modal {
    width: 98%;
  }
}

.payment-confirm-check {
  width: 100%;
  display: flex;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.0509803922), 0px 4px 8px 0px rgba(0, 0, 0, 0.0509803922);
  position: relative;
  margin-bottom: 6px;
}
@media (max-width: 1000px) {
  .payment-confirm-check {
    flex-direction: column;
  }
}
.payment-confirm-check .left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 12px;
  font-family: "Monsterrat 500" !important;
  text-align: center;
  width: 20%;
}
@media (max-width: 1000px) {
  .payment-confirm-check .left {
    width: 100%;
  }
}
.payment-confirm-check .left img {
  max-height: 120px;
  width: 120px;
  margin: 0 auto 0.5rem auto;
  object-fit: contain;
}
.payment-confirm-check .center {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  border-left: 1px solid #a9a4a4;
  border-right: 1px solid #a9a4a4;
}
@media (max-width: 1000px) {
  .payment-confirm-check .center {
    width: 100%;
    border: none;
    padding: 1rem 0 1rem 10px;
  }
}
.payment-confirm-check .center .item {
  display: flex;
  align-items: center;
  padding: 1px 12px;
}
@media (max-width: 767px) {
  .payment-confirm-check .center .item {
    flex-direction: column;
    align-items: flex-start;
  }
}
.payment-confirm-check .center .item .item-left {
  font-size: 13px;
  color: #5b5b5b;
  font-family: "Monsterrat 500" !important;
  width: 50%;
}
@media (max-width: 767px) {
  .payment-confirm-check .center .item .item-left {
    width: 100%;
  }
}
.payment-confirm-check .center .item .item-right {
  color: #000;
  font-family: "Monsterrat 500" !important;
  font-size: 13px;
  text-decoration: underline;
  width: 50%;
}
@media (max-width: 767px) {
  .payment-confirm-check .center .item .item-right {
    width: 100%;
  }
}
.payment-confirm-check .center .center-footer {
  width: 100%;
  display: flex;
  margin-top: 6px;
  border-top: 0.5px solid #a9a4a4;
}
.payment-confirm-check .center .center-footer > div {
  flex: 1 1;
  border-right: 0.5px solid #a9a4a4;
}
.payment-confirm-check .center .center-footer > div .footer-label {
  font-size: 11px;
  padding: 8px 4px;
  text-align: center;
  border-bottom: 0.5px solid #a9a4a4;
}
.payment-confirm-check .center .center-footer .footer-text {
  padding: 14px 10px;
  font-size: 11px;
  text-align: center;
  border-top: 0.5px solid #a9a4a4;
  font-family: "Monsterrat 500" !important;
}
.payment-confirm-check .right {
  width: 20%;
  padding: 0 12px;
}
@media (max-width: 1000px) {
  .payment-confirm-check .right {
    width: 100%;
    padding-bottom: 1.2rem;
  }
}
.payment-confirm-check .right .qr {
  width: 100px;
  height: 100px;
}

.payment-loading {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
}

.show-complex {
  height: auto;
  overflow: initial;
}

.unshow-complex {
  height: 0;
  overflow: hidden;
  display: none;
}

.last-transaction-button {
  color: #3e3e3e !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_payment.scss"],"names":[],"mappings":"AACE;EADF;IAEI,UAAA;EACF;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;AACF;AAAE;EACE,UAAA;AAEJ;AAAE;EACE,yBAAA;EACA,kBAAA;AAEJ;AAAE;EAVF;IAWI,UAAA;EAGF;AACF;AAFE;EAbF;IAcI,UAAA;EAKF;AACF;;AAFA;EACE,WAAA;EACA,aAAA;EACA,sGAAA;EACA,kBAAA;EACA,kBAAA;AAKF;AAJE;EANF;IAOI,sBAAA;EAOF;AACF;AANE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;AAQJ;AAPI;EAVF;IAWI,WAAA;EAUJ;AACF;AATI;EACE,iBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AAWN;AARE;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,8BAAA;EACA,+BAAA;AAUJ;AATI;EANF;IAOI,WAAA;IACA,YAAA;IACA,yBAAA;EAYJ;AACF;AAXI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAaN;AAZM;EAJF;IAKI,sBAAA;IACA,uBAAA;EAeN;AACF;AAdM;EACE,eAAA;EACA,cAAA;EACA,wCAAA;EACA,UAAA;AAgBR;AAfQ;EALF;IAMI,WAAA;EAkBR;AACF;AAhBM;EACE,WAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AAkBR;AAjBQ;EANF;IAOI,WAAA;EAoBR;AACF;AAjBI;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;AAmBN;AAlBM;EACE,SAAA;EACA,iCAAA;AAoBR;AAnBQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;AAqBV;AAlBM;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,wCAAA;AAoBR;AAhBE;EACE,UAAA;EACA,eAAA;AAkBJ;AAjBI;EAHF;IAII,WAAA;IACA,sBAAA;EAoBJ;AACF;AAnBI;EACE,YAAA;EACA,aAAA;AAqBN;;AAhBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,iBAAA;AAmBF;;AAjBA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AAoBF;;AAjBA;EACE,yBAAA;AAoBF","sourcesContent":[".payment-page {\n  @media (min-width: 1680px) {\n    width: 80%;\n  }\n}\n\n.selected-payment {\n  height: 37.9px;\n  padding: 11px;\n  border: 1px solid #d9d0d0;\n  border-radius: 10px;\n  background: #f6f6f6;\n  font-size: 12px;\n  color: #c8c8c8;\n  min-width: 145px;\n}\n\n.total-block {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  row-gap: 1rem;\n  margin-top: 5rem;\n}\n\n.payment-modal {\n  width: 50%;\n  max-height: 90%;\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #d9d9d9;\n    border-radius: 8px;\n  }\n  @media (min-width: 1000px) and (max-width: 1300px) {\n    width: 80%;\n  }\n  @media (max-width: 1000px) {\n    width: 98%;\n  }\n}\n\n.payment-confirm-check {\n  width: 100%;\n  display: flex;\n  box-shadow: 0px 10px 15px 0px #0000000d, 0px 4px 8px 0px #0000000d;\n  position: relative;\n  margin-bottom: 6px;\n  @media (max-width: 1000px) {\n    flex-direction: column;\n  }\n  .left {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    font-size: 12px;\n    font-family: \"Monsterrat 500\" !important;\n    text-align: center;\n    width: 20%;\n    @media (max-width: 1000px) {\n      width: 100%;\n    }\n    img {\n      max-height: 120px;\n      width: 120px;\n      margin: 0 auto 0.5rem auto;\n      object-fit: contain;\n    }\n  }\n  .center {\n    display: flex;\n    flex-wrap: wrap;\n    width: 80%;\n    border-left: 1px solid #a9a4a4;\n    border-right: 1px solid #a9a4a4;\n    @media (max-width: 1000px) {\n      width: 100%;\n      border: none;\n      padding: 1rem 0 1rem 10px;\n    }\n    .item {\n      display: flex;\n      align-items: center;\n      padding: 1px 12px;\n      @media (max-width: 767px) {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n      .item-left {\n        font-size: 13px;\n        color: #5b5b5b;\n        font-family: \"Monsterrat 500\" !important;\n        width: 50%;\n        @media (max-width: 767px) {\n          width: 100%;\n        }\n      }\n      .item-right {\n        color: #000;\n        font-family: \"Monsterrat 500\" !important;\n        font-size: 13px;\n        text-decoration: underline;\n        width: 50%;\n        @media (max-width: 767px) {\n          width: 100%;\n        }\n      }\n    }\n    .center-footer {\n      width: 100%;\n      display: flex;\n      margin-top: 6px;\n      border-top: 0.5px solid #a9a4a4;\n      > div {\n        flex: 1;\n        border-right: 0.5px solid #a9a4a4;\n        .footer-label {\n          font-size: 11px;\n          padding: 8px 4px;\n          text-align: center;\n          border-bottom: 0.5px solid #a9a4a4;\n        }\n      }\n      .footer-text {\n        padding: 14px 10px;\n        font-size: 11px;\n        text-align: center;\n        border-top: 0.5px solid #a9a4a4;\n        font-family: \"Monsterrat 500\" !important;\n      }\n    }\n  }\n  .right {\n    width: 20%;\n    padding: 0 12px;\n    @media (max-width: 1000px) {\n      width: 100%;\n      padding-bottom: 1.2rem;\n    }\n    .qr {\n      width: 100px;\n      height: 100px;\n    }\n  }\n}\n\n.payment-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 10px;\n}\n\n.show-complex {\n  height: auto;\n  overflow: initial;\n}\n.unshow-complex {\n  height: 0;\n  overflow: hidden;\n  display: none;\n}\n\n.last-transaction-button {\n  color: #3e3e3e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
